const single_sign_on = {
    forbidden_domains: 'Genel e-posta alanı domainleri izin verilmiyor.',
    duplicated_domains: 'Yinelenmiş domainler bulunmaktadır.',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
